import axios from 'axios';

const api = axios.create({
  baseURL: 'https://72f8a2da3439.ngrok-free.app',
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      sessionStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export default api;
